import { useEffect, useState } from "react";
import { getConfigurationsTestsByCompanyId, postConfigurationsTests } from "../../../../features/search/service/config-tests";
import { getMe } from "../../../../features/search/service/user-service";
import { getLanguagesSelect } from "../../../../features/search/service/languages-service";
import { User } from "../../../../shared/types/user";
import { SelectOption } from "../../../../shared/types/select-options";
import InputComponent from "../../../../components/input/input";
import ButtonComponent from "../../../../components/button/button";
import SelectComponent from "../../../../components/input/select";
import { MenuTop } from '../../../../components/menu/top/menu-top';
import { useNavigate } from "react-router-dom";
import './styles/add.css';

export const AdminConfigsAdd = () => {
    const navigate = useNavigate();

    const [me, setMe] = useState<User | null>(null);
    const [firstValue, setFirstValue] = useState<string>('');
    const [secondValue, setSecondValue] = useState<string>('');
    const [currency, setCurrency] = useState<string>('');
    const [languageId, setLanguageId] = useState<string>('');
    const [languages, setLanguages] = useState<SelectOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe();
                setMe(userData);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
            }
        };
        fetchUser();
    }, []);

    useEffect(() => {
        if (!me) return;

        const fetchData = async () => {
            try {
                if (me.company?.id) {
                    const configsTests = await getConfigurationsTestsByCompanyId(me.company.id);
                }

                const languagesData = await getLanguagesSelect();
                
                if (languagesData && languagesData.length > 0) {
                    setLanguages(languagesData);
                    if (!languageId) {
                        setLanguageId(String(languagesData[0].id));
                    }
                }
            } catch (error) {
                console.error('❌ Erro ao buscar dados:', error);
            }
        };

        fetchData();
    }, [me]);

    const addConfig = async () => {
        if (!firstValue || !secondValue || !currency || !languageId) {
            return;
        }

        if (!me?.company?.id) {
            return;
        }

        const payload = {
            firstValue,
            secondValue,
            currency,
            companyId: me.company.id,
            languageId: String(languageId)
        };

        setLoading(true);

        try {
            const configsTests = await postConfigurationsTests(payload);
            
            alert('Configuração adicionada com sucesso!');
            
            setFirstValue('');
            setSecondValue('');
            setCurrency('');

            if (configsTests) {
                navigate('/admin-painel');
            }
        } catch (error) {
            console.error('❌ Erro ao adicionar configuração:', error);
            alert('Erro ao adicionar configuração. Verifique os dados e tente novamente.');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div>
            <MenuTop />
            <div className="configs-container">
                <h1>Configurações para aplicação do Teste</h1>
                
                <InputComponent 
                    id="id-input-firstValue" 
                    label="Valor Atrasado" 
                    value={firstValue} 
                    onChange={(event) => setFirstValue(event.target.value)} 
                />
                
                <InputComponent 
                    id="id-input-secondValue" 
                    label="Valor Adiantado" 
                    value={secondValue} 
                    onChange={(event) => setSecondValue(event.target.value)} 
                />
                
                <InputComponent 
                    id="id-input-currency" 
                    label="Moeda" 
                    value={currency} 
                    onChange={(event) => setCurrency(event.target.value)}
                />
                
                {languages.length > 0 && (
                    <SelectComponent
                        label="Idioma"
                        value={languageId}
                        onChange={(value) => setLanguageId(String(value))}
                        options={languages}
                        styles={{ marginTop: '10px' }}
                    />
                )}

                <div className="button-container">
                    <ButtonComponent
                        label={loading ? "Criando..." : "Criar Configuração"}
                        onClick={addConfig}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    );
}